package com.gsb.vyapar.bhagya.util

class LinkedList<T> {
    private var head: Node<T>? = null
    private var tail: Node<T>? = null
    private var size = 0

    inner class Node<T>(var data: T) {
        var next: Node<T>? = null
    }

    fun addFirst(data: T) {
        val newNode = Node(data)
        if (head == null) {
            head = newNode
            tail = newNode
        } else {
            newNode.next = head
            head = newNode
        }
        size++
    }

    fun addLast(data: T) {
        val newNode = Node(data)
        if (tail == null) {
            head = newNode
            tail = newNode
        } else {
            tail?.next = newNode
            tail = newNode
        }
        size++
    }

    fun removeFirst(): T? {
        if (head == null) {
            return null
        }
        val removedData = head!!.data
        if (head == tail) {
            head = null
            tail = null
        } else {
            head = head!!.next
        }
        size--
        return removedData
    }

    fun removeLast(): T? {
        if (tail == null) {
            return null
        }
        val removedData = tail!!.data
        if (head == tail) {
            head = null
            tail = null
        } else {
            var current = head
            while (current?.next != tail) {
                current = current?.next
            }
            tail = current
            tail?.next = null
        }
        size--
        return removedData
    }

    fun getLast(): T? {
        return tail?.data
    }

    fun isEmpty(): Boolean {
        return size == 0
    }

    fun size(): Int {
        return size
    }
}

